import { TypeTensionLink } from '../models/request-and-responses/rest-api/enums/typeTensionLink.enum';

interface IPodTensionObject {
    value: TypeTensionLink;
    label: string;
}

export const PodTensionObjects: IPodTensionObject[] = [
    {
        value: TypeTensionLink.Low220,
        label: '220 V'
    },
    {
        value: TypeTensionLink.Low380,
        label: '380 V'
    },
    {
        value: TypeTensionLink.Medium15,
        label: '15 kV'
    },
    {
        value: TypeTensionLink.Medium20,
        label: '20 kV'
    }
];



// WEBPACK FOOTER //
// ./src/app/helpers/podTensionObjects.ts